import { FloorPlan } from "../objects/FloorPlan";
import { Wall } from "../objects/Walls/Wall";
import { Action } from "./Action";
import { SaveAction } from "./SaveAction";

export class DeleteWallAction implements Action {

    private wall:Wall; //TODO: Add node data pt undo/redo
    private receiver:FloorPlan;

    constructor(wall:Wall) {
        this.wall = wall;
        this.receiver = FloorPlan.Instance;
    }

    public execute(): void {
        this.receiver.actions.push(this);
        this.receiver.removeWall(this.wall);
        const node:any = new SaveAction();
        node.execute();
    }
}

